import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gears-icon',
  templateUrl: './gears-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GearsIconComponent {}
